import { useSelector } from "react-redux";
import Container from "../../../components/element/container";
import Col from "../../../components/element/col";
import Image from "../../../components/element/image";
import { DcLogo, ShowroomGoogleMap, ShowroomWaze, ShowroomWhatsapp } from "../../../assets/images";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { Skeleton } from "primereact/skeleton";
import Row from "../../../components/element/row";
import { useTranslation } from "react-i18next";
import useWindowDimension from "../../../components/hook/use.window.dimension";

export default function ShowroomList() {
  const { t } = useTranslation();
  const {
  isDesktop
} = useWindowDimension();
  const { showroomList, showroomLoading } = useSelector(
    (state) => state.common,
  );

  const openLink = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const getLocationQuery = (showroom) =>
    encodeURIComponent(showroom.location || showroom.name || "DCAR Malaysia");

  const handleWaze = (showroom) => {
    openLink(
      showroom.waze_link ||
        `https://www.waze.com/ul?q=${getLocationQuery(showroom)}`,
    );
  };

  const handleMap = (showroom) => {
    openLink(
      showroom.google_link ||
        `https://www.google.com/maps/search/?api=1&query=${getLocationQuery(showroom)}`,
    );
  };

  const handleWhatsapp = (showroom) => {
    openLink(showroom.whatsapp_link);
    // const message = encodeURIComponent(
    //   "Hi, I would like to enquire about your showroom.",
    // );
    // openLink(`https://wa.me/60126566969?text=${message}`);
  };

  return (
    <Container className="showroom-list">
      <Col className="_col showroom-card-list">
        {showroomLoading
          ? Array.from({ length: 2 }, (_, showroomSkeleton) => (
              <Col
                className="_col showroom-card-wrap showroom-skeleton-card"
                key={showroomSkeleton}
              >
                <Skeleton className="showroom-card-loading" />
              </Col>
            ))
          : showroomList.map((showroom, showroomIndex) => (
              <Col
                key={`${showroom.id || "showroom"}-${showroomIndex}`}
                className="_col showroom-card-wrap"
              >
                <Col className="_col showroom-item">
                  <Swiper
                    spaceBetween={0}
                    grabCursor={true}
                    slidesPerView={1}
                    modules={[Pagination]}
                    pagination={{ clickable: true }}
                  >
                    {showroom.media?.length > 0 ? (
                      showroom.media.map((media, mediaIndex) => (
                        <SwiperSlide
                          key={mediaIndex}
                          style={{
                            backgroundImage: `url(${media.url})`,
                            touchAction: "pan-x",
                          }}
                        />
                      ))
                    ) : (
                      <SwiperSlide className="showroom-media-default">
                        <img src={DcLogo} alt="DCAR" />
                      </SwiperSlide>
                    )}
                  </Swiper>

                  <Col className="_col state-badge">
                    <p className="_label showroom-state">
                      {showroom.state || t("Malaysia")}
                    </p>
                  </Col>
                  <Col className="_col showroom-info">
                    <h4 className="_label showroom-title">{showroom.name}</h4>
                    <p className="_label showroom-subtitle">
                      {showroom.location}
                    </p>
                    <Col className="_col showroom-divider" />
                  </Col>
                </Col>
                <Row className="_row showroom-card-footer">
                  {(showroom.waze_link ||
                    showroom.google_link ||
                    showroom.whatsapp_link) && (
                    <Row className="_row showroom-actions">
                      {showroom.waze_link && (
                        <button
                          type="button"
                          className="_button showroom-action waze"
                          onClick={() => handleWaze(showroom)}
                        >
                          <Image
                            src={ShowroomWaze}
                            alt={t("Open showroom in Waze")}
                            className="_img action"
                          />
                        </button>
                      )}
                      {showroom.google_link && (
                        <button
                          type="button"
                          className="_button showroom-action map"
                          onClick={() => handleMap(showroom)}
                        >
                          <Image
                            src={ShowroomGoogleMap}
                            alt={t("Open showroom in Google Maps")}
                            className="_img action"
                          />
                        </button>
                      )}
                      {showroom.whatsapp_link && (
                        <button
                          type="button"
                          className="_button showroom-action whatsapp"
                          onClick={() => handleWhatsapp(showroom)}
                        >
                          <Image
                            src={ShowroomWhatsapp}
                            alt={t("Contact showroom on WhatsApp")}
                            className="_img action"
                          />
                        </button>
                      )}
                    </Row>
                  )}
                  {showroom.operation_hours?.length > 0 && (
                    <Col
                      className="_col operation-info"
                      style={{
                        alignItems: !(
                          showroom.waze_link ||
                          showroom.google_link ||
                          showroom.whatsapp_link
                        )
                          ? "start"
                          : "",
                      }}
                    >
                      <p className="_label operation-title">
                        {t("Operation Hours")}
                      </p>
                      <Container tag="div"
                        className={
                          !isDesktop
                            ? "flex flex-wrap items-center justify-end gap-2 row-gap-0"
                            : ""
                        }
                      >
                        {showroom.operation_hours.map((hour, hourIndex) => (
                          <p
                            className="_label operation-subtitle"
                            key={hourIndex}
                          >
                            {hour}
                            {hourIndex !== showroom.operation_hours?.length - 1
                              ? ","
                              : ""}
                          </p>
                        ))}
                      </Container>
                    </Col>
                  )}
                </Row>
              </Col>
            ))}
      </Col>
    </Container>
  );
}
